/* eslint-disable react/jsx-pascal-case */
import {
    Col, Form, Input, Row, Select, InputNumber
} from "./../../ui/ot";
import React, { useEffect } from "react";
import { useTemplateType } from "../../template/controller/TemplateTypeController";
const CanForm = (
    {
        propsForm = null,
        axiosMode = "post",
        formReloadCount = 0,
        onFormFinish = () => { },
        field
    }
) => {
    const [form] = Form.useForm();

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getTemplateTypeOption()
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }
    const {
        getTemplateTypeOption,
        templateTypeOption
    } = useTemplateType({
        onBefore: () => { },
        onFinish: () => { }
    })

    useEffect(() => {
        setDataInitialization()

    }, [])

    useEffect(() => {

        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                label={"can_id"}
                                name={[field?.name, "can_id"]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"模板名稱"}
                                name={[field?.name, "name"]}
                                rules={[
                                    {
                                        required: true,
                                        message: "此為必填"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"模板分類"}
                                name={[field?.name, 'template_type_id']}
                            >
                                <Select
                                    allowClear={true}
                                    options={templateTypeOption}
                                >

                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"頻率"}
                                name={[field?.name, 'frequently']}
                                hidden={true}
                                initialValue={0}
                            >
                                <InputNumber />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.List
                                name={[field?.name, "message"]}
                                initialValue={[
                                    {
                                        component: "TEXT",
                                        content: null
                                    }
                                ]}
                            >
                                {
                                    (fields, { add, remove }) => (
                                        <Row>
                                            {
                                                fields.map((field) => (
                                                    <Col span={24}>
                                                        <Row>
                                                            <Col span={24}>
                                                                <Form.Item
                                                                    label={"component"}
                                                                    name={[field.name, 'component']}
                                                                    hidden={true}
                                                                >
                                                                    <Input>
                                                                    </Input>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24}>
                                                                <Form.Item
                                                                    label={"訊息內容"}
                                                                    name={[field.name, 'content']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "此為必填"
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Input.TextArea>
                                                                    </Input.TextArea>
                                                                </Form.Item>
                                                            </Col>

                                                        </Row>

                                                    </Col>
                                                ))
                                            }
                                        </Row>
                                    )
                                }

                            </Form.List>
                        </Col>



                    </Row>
                </Form>
            </Col>
        </Row>
    )
}



export default CanForm;
